import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toAppPath } from "../../lib/appNavigation";
import { getInternalPathFromLocation } from "../../lib/routeTokens";
import { authSelector } from "../Auth/AuthSlice";
import { findFirstAllowedAbacRoute } from "../User/Abac/abacRouteMap";
import { useAbacSessionPending } from "../../hooks/useAbacAccess";
import AppShellSkeleton from "../../Layouts/AppShellSkeleton";
import NoAccessPage from "./NoAccessPage";

/**
 * Fallback target for blocked / unknown routes. Tries the first allowed page
 * for a multi-access member; if none remain, show No Access.
 * Re-runs when websocket permission pushes change the allowed set.
 */
const RedirectToDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, abacPermissions } = useSelector(authSelector);
  const abacPending = useAbacSessionPending();

  const currentPath = getInternalPathFromLocation(location).split("?")[0];
  const fallback = findFirstAllowedAbacRoute(
    abacPermissions,
    user,
    globalThis.profileData,
    { exclude: currentPath }
  );
  const alreadyOnFallback = Boolean(fallback) && currentPath === fallback;

  useEffect(() => {
    if (abacPending || !fallback || alreadyOnFallback) return;
    navigate(toAppPath(fallback), { replace: true });
  }, [abacPending, fallback, alreadyOnFallback, navigate]);

  if (abacPending) return <AppShellSkeleton />;
  if (!fallback) return <NoAccessPage />;
  return <AppShellSkeleton />;
};
export default RedirectToDashboard;
